var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7L6.33333 7M17 1.85714L6.33333 1.85714M17 12.1429L6.33333 12.1429M2.77778 7C2.77778 7.47339 2.37981 7.85714 1.88889 7.85714C1.39797 7.85714 1 7.47339 1 7C1 6.52661 1.39797 6.14286 1.88889 6.14286C2.37981 6.14286 2.77778 6.52661 2.77778 7ZM2.77778 1.85714C2.77778 2.33053 2.37981 2.71429 1.88889 2.71429C1.39797 2.71429 1 2.33053 1 1.85714C1 1.38376 1.39797 1 1.88889 1C2.37981 1 2.77778 1.38376 2.77778 1.85714ZM2.77778 12.1429C2.77778 12.6162 2.37981 13 1.88889 13C1.39797 13 1 12.6162 1 12.1429C1 11.6695 1.39797 11.2857 1.88889 11.2857C2.37981 11.2857 2.77778 11.6695 2.77778 12.1429Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.a23a469b52c80d0477beefba95b0ac8a.svg";
export { ForwardRef as ReactComponent };